import React from 'react';
import { useState } from 'react';
export const DeleteAccount = () => {

    const [email, setEmail] = useState('')
    const [showPopup, setShowPopup] = useState(false);
    const containerStyle = {
        width: '100%',
        maxWidth: '400px',
        background: '#fff',
        padding: '30px',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
        borderRadius: '12px',
        textAlign: 'center',
        margin: 'auto',
        marginTop: '30vh'
    };

    const popupStyle = {
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    };

    const popupContentStyle = {
        background: '#fff',
        padding: '20px',
        borderRadius: '8px',
        textAlign: 'center',
        width: '90%',
        maxWidth: '400px'
    };

    const footerStyle = {
        marginTop: '20px',
        fontSize: '12px',
        color: '#aaa'
    };

    const buttonStyle = {
        width: '100%',
        padding: '12px',
        fontSize: '16px',
        color: '#fff',
        backgroundColor: '#2a7ae2',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        transition: 'background-color 0.3s',
        marginTop: '10px'
    };

    const inputStyle = {
        width: '100%',
        padding: '12px',
        marginBottom: '20px',
        border: '1px solid #ddd',
        borderRadius: '8px',
        fontSize: '16px',
        transition: 'border-color 0.3s'
    };
    const submitRequest = () => {
        if (email) {
            setShowPopup(true);
        } else {
            alert('Please enter your email address.')
        }
    };
    return (
        <div style={containerStyle}>
            <h2 style={{ color: "orange" }}>Delete Your Account</h2>
            <p>Please enter your registered email address to request account deletion.</p>

            <form onSubmit={(e) => e.preventDefault()}>
                <input
                    type="email"
                    id="email"
                    name="email"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    style={inputStyle}
                />
                <button type="button" onClick={submitRequest} className='formBtn'>Submit Request</button>
            </form>

            {showPopup && (
                <div style={popupStyle}>
                    <div style={popupContentStyle}>
                        <p>Account deletion request has been submitted for {email}.</p>
                        <button onClick={() => setShowPopup(false)} style={buttonStyle}>Close</button>
                    </div>
                </div>
            )}

            <div style={footerStyle}>&copy; 2024 IND Matrimony. All rights reserved.</div>
        </div>
    );
};
